/**
 * Progressive disclosure for the control panel (feature A-103). Each control group is a native
 * <details data-acc="..."> — Run defaults open, Faults/Trip a control/Try it default closed.
 * Whatever an operator leaves open/closed is remembered per browser (localStorage), so returning
 * to the dashboard doesn't force re-expanding the groups they actually use every run.
 */

const STORAGE_PREFIX = 'ts_acc_';

function storageKey(id: string): string {
  return `${STORAGE_PREFIX}${id}`;
}

function readStored(id: string): boolean | null {
  try {
    const raw = localStorage.getItem(storageKey(id));
    if (raw === null) return null;
    return raw === '1';
  } catch {
    return null; // localStorage unavailable (e.g. private mode) — fall back to the HTML default
  }
}

function writeStored(id: string, open: boolean): void {
  try {
    localStorage.setItem(storageKey(id), open ? '1' : '0');
  } catch {
    /* ignore — state just won't persist */
  }
}

/** Apply any remembered open/closed state, then keep it in sync as the operator toggles groups. */
export function initAccordions(doc: Document = document): void {
  doc.querySelectorAll<HTMLDetailsElement>('details[data-acc]').forEach((el) => {
    const id = el.getAttribute('data-acc') ?? '';
    if (!id) return;

    const stored = readStored(id);
    if (stored !== null) el.open = stored;

    el.addEventListener('toggle', () => writeStored(id, el.open));
  });
}
